import Form, { GroupItem, SimpleItem } from "devextreme-react/form";
import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { Contract, Users } from "../contracts/type";
import { MobileScreen, Notification } from "./type";
import React from "react";
import { adminContracts, adminSendNotification, getMobileScreenUrl, getUsersUrl, productUrl } from "../../services/urls";
import DataGrid, {
    Selection, FilterRow, Column, Paging,
} from 'devextreme-react/data-grid';
import { Button } from "devextreme-react";
import { DropDownOptions } from 'devextreme-react/drop-down-box';
import { DropDownGrid, FileUploader } from "../../components";
import { Product } from "../products/types";
import { OpenTicket } from "../TicketManagement/types";
import notify from "devextreme/ui/notify";

const NotificationPage = () => {
    const localize = useSelector(getLocalized);
    const [users, setUsers] = React.useState<Users[]>([]);
    const [contracts, setContracts] = useState<Contract[]>([])
    const [tickets, setTickets] = useState<OpenTicket[]>([])
    const [selectedRowKeys,setSelectedRowKeys] = useState([])
    const [, setSelectionChangedBySelectBox] = useState(false);
    const { token, lang } = useSelector(getApiParams);
    const [products, setProducts] = useState<Product[]>([])
    const [value, setValue] = useState(0)
    const tableRef = useRef<any>();
    const [mobileScreen, setMobileScreen] = useState<MobileScreen[]>([])
    const [, setId] = useState("");


    const data = useRef<Notification>({
        Users: [],
        Title: "",
        Message: "",
        Image: "",
        EntityId: "",
        ScreenId: 1,
    })
    const getUsers = useCallback((async () => {
        const response: ApiResponse<Users[]> = await createRequest({
            method: "GET",
            url: getUsersUrl,
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setUsers(response.Result)
        }
    }), [token, lang])

    const getScreen = useCallback((async () => {
        const response: ApiResponse<MobileScreen[]> = await createRequest({
            method: "GET",
            url: getMobileScreenUrl,
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setMobileScreen(response.Result)
        }
    }), [token, lang])
    const getProducts = useCallback((async () => {
        const response: ApiResponse<Product[]> = await createRequest({
            method: "GET",
            url: productUrl,
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setProducts(response.Result)
        }
    }), [token, lang])
    const getTickets = useCallback((async () => {
        const response: ApiResponse<OpenTicket[]> = await createRequest({
            method: "GET",
            url: "api/tickets",
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setTickets(response.Result)
        }
    }), [token, lang])

    const onSelectionChanged = async ({ selectedRowKeys }: any) => {
        setSelectedRowKeys(selectedRowKeys)
        setSelectionChangedBySelectBox(true);
        data.current.Users = selectedRowKeys
    }

    const getContracts = useCallback((async () => {
        const response: ApiResponse<Contract[]> = await createRequest({
            method: "GET",
            url: adminContracts,
            bodyType: BodyType.formdata,
            token,
            body: {},
            lang,
        });
        if (verfiyResponse(response)) {
            setContracts(response.Result)
        }
    }
    ), [token, lang])
    const setColums = (item: any) => {
        switch (item) {
            case 3:
                return [
                    {
                        dataField: "Code",
                        caption: localize.getString("code")
                    },
                    {
                        dataField: "Name",
                        caption: localize.getString("name")
                    }
                ]
            case 13:
                return [
                    {
                        dataField: "Code",
                        caption: localize.getString("code")
                    },
                    {
                        dataField: "UserName",
                        caption: localize.getString("username")
                    },
                    {
                        dataField: "Subject",
                        caption: localize.getString("subject")
                    }
                ]
            case 16:
                return [
                    {
                        dataField: "Message",
                        caption: localize.getString("message")
                    },
                    {
                        dataField: "UserName",
                        caption: localize.getString("username")
                    }
                ]
            default:
                return [];
        }
    }

    const setDataSource = (item: any) => {
        switch (item) {
            case 3:
                return products
            case 13:
                return tickets
            case 16:
                return contracts
            default:
                return []
        }
    }

    const setName = (item: any) => {
        switch (item) {
            case 3:
                return "Name";
            case 13:
                return "Subject"
            case 16:
                return "Message";
            default:
                return "";
        }
    }
    useEffect(() => {
        getUsers();
        getScreen();
        getTickets();
        getProducts();
        getContracts();
    }, [getContracts, getProducts, getScreen, getTickets, getUsers])

    return (
        <>
            <form>
                <div>
                    <p
                        style={{
                            fontSize: "24px",
                            fontWeight: 600,
                            padding: "10px"
                        }}
                    >{localize.getString("notificationForm")}</p>
                </div>
                <Form
                    formData={data.current}
                    key="Id"
                    ref={tableRef}
                >
                    <GroupItem colCount={2}>
                        <GroupItem colCount={1}>
                            <SimpleItem
                                dataField="Title"
                                editorType={"dxTextBox"}

                                editorOptions={{
                                    inputAttr: {
                                        style: " text-transform: capitalize",
                                    },
                                }}
                                label={{ text: "Title" }}
                            >
                            </SimpleItem>
                            <SimpleItem
                                dataField="Message"
                                editorType={"dxTextBox"}
                                editorOptions={{
                                    inputAttr: {
                                        style: " text-transform: capitalize",
                                    },
                                }}
                                label={{ text: localize.getString("message") }}
                            >
                            </SimpleItem>

                            <SimpleItem
                                dataField={"ScreenId"}
                                editorType="dxLookup"
                                label={{ text: localize.getString("screen") }}
                                render={(item: any) => (
                                    <DropDownGrid
                                        dataSource={mobileScreen}
                                        columns={["Code"]}
                                        displayExpr="Code"
                                        returnSelectedId={async (id: any) => {
                                            item.editorOptions.value = id;
                                            data.current.ScreenId = id
                                            setValue(id)

                                        }}

                                        value={data.current.ScreenId}
                                        dropDownOptions={{ width: 900 }} />
                                )}
                            >
                                <DropDownOptions closeOnOutsideClick showTitle={false} />
                            </SimpleItem>
                            <SimpleItem
                                dataField="EntityId"
                                editorType="dxLookup"
                                label={{ text: "Entity" }}
                                render={(item: any) => (
                                    <DropDownGrid
                                        dataSource={setDataSource(value)}
                                        columns={setColums(value)}
                                        displayExpr={setName(value)}
                                        returnSelectedId={async (id: any) => {
                                            item.editorOptions.value = id
                                            data.current.EntityId = id
                                            setId(id);
                                        }}
                                        value={data.current.EntityId}
                                        dropDownOptions={{ width: 900 }}
                                    />
                                )}
                            >
                                <DropDownOptions closeOnOutsideClick showTitle={false} />
                            </SimpleItem>
                            {/* <SimpleItem
                                dataField="EntityId"
                                editorType="dxLookup"
                                label={{ text: "Entity" }}
                                render={(item: any) => (
                                    <DropDownGrid
                                        dataSource={users}
                                        selectionMode="multiple"
                                        columns={["Name","Surname","Username","Email","Phone"]}
                                        displayExpr="Name"
                                        returnSelectedId={async (id: any) => {
                                            item.editorOptions.value = id
                                            data.current.Users = id
                                            setId(id);
                                        }}
                                        value={data.current.EntityId}
                                        dropDownOptions={{ width: 900 }}
                                    />
                                )}
                            >
                                <DropDownOptions closeOnOutsideClick showTitle={false} />
                            </SimpleItem> */}
                            <SimpleItem
                                dataField={`Image[0].Document`}
                                label={{
                                    text: localize.getString("image")
                                }}
                            >
                                <FileUploader
                                    buttonText={localize.getString("addImage")}
                                    onValueChanged={(values) => (data.current.Image = values[0].name)}
                                />
                            </SimpleItem>
                            <SimpleItem
                                render={() => (
                                    <DataGrid
                                        id="grid-container"
                                        dataSource={users}
                                        showBorders={true}
                                        keyExpr="Id"
                                        selectedRowKeys={selectedRowKeys}
                                        onSelectionChanged={onSelectionChanged}

                                    >
                                        <Selection
                                            mode="multiple"
                                        />
                                        <FilterRow visible={true} />
                                        <Paging pageSize={10}></Paging>
                                        <Column dataField="Name" caption={localize.getString("name")} />
                                        <Column dataField="Surname" caption={localize.getString("surname")} />
                                        <Column dataField="UserName" caption={localize.getString("username")} />
                                        <Column dataField="Email" caption={localize.getString("email")} />
                                        <Column dataField="Phone" caption={localize.getString("phone")} />
                                    </DataGrid>
                                )}
                            >

                            </SimpleItem>
                        </GroupItem>
                    </GroupItem>
                    <GroupItem colCount={2}>
                        <SimpleItem>
                            <Button
                                type="success"
                                text="Gönder"
                                style={{
                                    display: "flex",
                                    width: "100px",
                                    justifyContent: "center",
                                    float: "right",
                                    marginBottom: "25px"
                                }}
                                onClick={async () => {
                                    const response: ApiResponse<Notification> = await createRequest({
                                        method: "POST",
                                        url: adminSendNotification,
                                        bodyType: BodyType.formdata,
                                        token,
                                        body: data.current,
                                        lang,
                                    });
                                    if (verfiyResponse(response)) {
                                        notify(response.Message, "success")
                                        tableRef?.current.instance.resetValues();

                                    } else {
                                        notify(response.Message)
                                    }
                                }}
                            >
                            </Button>
                        </SimpleItem>
                    </GroupItem>
                </Form>
            </form>

        </>
    );
};
export default NotificationPage;
